import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../api/client";
import { invitesKey } from "../api/hooks/useInvites";
import type { Invite } from "../api/types";

export interface CreateInviteInput {
  readonly role: "owner" | "member" | "viewer";
  readonly expiresAt?: number;   // epoch-ms
  readonly email?: string;       // optional recipient; server emails the link
}

export function useCreateInvite(slug: string) {
  const qc = useQueryClient();
  return useMutation<Invite, ApiError, CreateInviteInput>({
    mutationFn: (input) =>
      apiFetch<Invite>(`/api/ws/${slug}/invites`, { method: "POST", body: input }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: invitesKey(slug) });
    },
  });
}
